import styles from "@/styles/buying-guide/detail.module.scss";
import Head from "next/head";
import { useEffect, useState } from "react";
import DefaultLayout from "@/components/DefaultLayout";
import BreadCrum from "@/components/global/BreadCrum";
import GuidesItem from '@/components/buying-guide/GuidesItem'
import { Button, Skeleton } from "antd";
import Link from "next/link";
import Image from "next/image";
import buyingGuidesApi from "@/service/modules/buyingGuidesApi";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;

export default function BuyingGuidesDetail() {
  interface BreadcrumbItem {
    name: string;
    url: string;
    current: boolean;
  }

  interface PopularBuyingGuidesItem {
    categoryID?: number;
    name: string;
    guideUrl: string;
    detailGuideUrl?: string;
    imgUrl: string;
    seoDescription: string | null;
  }

  const [breadCrumb, setBreadCrumb] = useState<BreadcrumbItem[]>([]);
  const [guideDetail, setGuideDetail] = useState<Record<string, any>>({});
  const [relatedGuideData, setRelatedGuideData] = useState<PopularBuyingGuidesItem[]>([]);

  // 获取Guide模块数据
  async function getBuyingGuidesDetail() {
    try {
      let guideDetailUrl = new URL(window.location.href).pathname.replace(/^\/|\/$/g, '');
      let resData = await buyingGuidesApi.getBuyingGuidesDetail({
        guideDetailUrl,
      });

      if (resData.data && resData.data && resData.data.detail) {
        if (resData.data.detail.relatedGuide && resData.data.detail.relatedGuide.length) {
          resData.data.detail.relatedGuide.forEach((item: any) => {
            item.name = item.seoTitle
          });
        }

        setGuideDetail(resData.data.detail);
        setRelatedGuideData(resData.data.detail.relatedGuide);
      }
    } catch (error) {
      console.log(`获取Guide详情数据失败: `, error);
    }
  }

  useEffect(() => {
    getBuyingGuidesDetail();
  }, []);

  useEffect(() => {
    if (guideDetail.name) {
      setBreadCrumb([
        {
          name: guideDetail.name,
          url: `/${guideDetail.categoryUrl}`,
          current: false,
        },
        {
          name: `${guideDetail.name} Guides`,
          url: `${guideDetail.guideUrl}`,
          current: true,
        },
      ]);
    }
  }, [guideDetail]);

  useEffect(() => {
    const loadFacebookSDK = () => {
      if (window && (window as any).FB) return; // 如果已经加载了 SDK，则直接返回

      (window as any).fbAsyncInit = function () {
        (window as any).FB.init({
          appId: "898035696881938", // 替换为你的 App ID
          xfbml: true,
          version: "v2.2",
        });
      };

      const scriptId = "facebook-jssdk";
      if (!document.getElementById(scriptId)) {
        const js = document.createElement("script");
        js.id = scriptId;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        const fjs = document.getElementsByTagName("script")[0];
        fjs?.parentNode?.insertBefore(js, fjs);
      }
    };

    const loadAddThisScript = () => {
      const addThisScriptId = "addthis-js";
      if (!document.getElementById(addThisScriptId)) {
        const script = document.createElement("script");
        script.id = addThisScriptId;
        script.type = "text/javascript";
        script.src =
          "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-570f49d5e46f529b";
        script.async = true; // 确保脚本异步加载
        document.body.appendChild(script);
      }
    };

    // 确保代码仅在客户端执行
    if (typeof window !== "undefined") {
      loadFacebookSDK();
      loadAddThisScript();
    }
  }, []); // 只在组件挂载时执行一次


  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    // 获取元素的宽度
    const reviewsList = document.getElementById('articleContent');
    if (reviewsList) {
      setWidth(reviewsList.offsetWidth - 48);
    }

    // 可选：添加事件监听器，监听窗口大小变化
    const handleResize = () => {
      if (reviewsList) {
        setWidth(reviewsList.offsetWidth - 48);
      }
    };
    window.addEventListener('resize', handleResize);

    // 清理事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // 空数组确保仅在组件挂载时运行一次

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles["page-buying-guides-detail"]}`}>
          {/* 面包屑 */}
          {!!(breadCrumb && breadCrumb.length) && (
            <BreadCrum BreadList={breadCrumb}></BreadCrum>
          )}

          <div className={styles["content"]} id="content">
            <div className={styles["banner-box"]}>
              {guideDetail.bannerImgUrl ? (
                <Image
                  className={styles["banner-image"]}
                  alt="crazysales"
                  width={1200}
                  height={400}
                  src={guideDetail.bannerImgUrl}
                />
              ) : null }

              <div className={styles["guide-detail-txt"]}>
                {guideDetail.seoTitle}
              </div>
            </div>

            <div className={styles["article-content-box"]} id="articleContent">
              <div className={styles["share-title"]}>Share:</div>

              <div className={styles["article-date-box"]}>
                <div className={styles["article-date-left"]}>
                  <div className={styles["date"]}>
                    By{" "}
                    <span style={{ color: "#e60012" }}>
                      {guideDetail.author}
                    </span>
                  </div>
                  <div className={styles["updated"]}>
                    Last updated: {guideDetail.addTime}
                  </div>
                </div>

                <Button
                  size="small"
                  href={`/${guideDetail.categoryUrl}`}
                  className={styles["article-category"]}
                >
                  Shop {guideDetail.name}
                </Button>
              </div>

              {guideDetail.content ? (
                <div
                  className={styles["article-content"]}
                  dangerouslySetInnerHTML={{ __html: guideDetail.content }}
                ></div>
              ) : <Skeleton></Skeleton>}

              <div className={styles["back-to-guide-box"]}>
                <Button
                  className={styles["back-to-guide"]}
                  type="primary"
                  href={`${guideDetail.guideUrl}`}
                >
                  Back to {guideDetail.name} Guides
                </Button>
              </div>

              <div className={styles["reviews-list"]}>
                <Link
                  href={`/${guideDetail.categoryUrl}reviews/`}
                  legacyBehavior
                >
                  <a
                    className={styles["reviews-item"]}
                    rel="noopener noreferrer"
                  >
                    <Image
                      className={styles["item-icon"]}
                      src={`${imageDomain}/svg/model-photos.svg`}
                      alt={"reviews"}
                      width={54}
                      height={54}
                    />

                    <div className={styles["item-text-box"]}>
                      <div className={styles["item-text-title"]}>
                        {`${guideDetail.name} reviews`}
                      </div>
                      <div className={styles["item-text-desc"]}>
                        {`Check Latest Reviews for ${guideDetail.name} Online, Independent and trusted buying guides, prices, and comparisons from Crazysales.com.au`}
                      </div>
                    </div>
                  </a>
                </Link>
              </div>

              {
                relatedGuideData && relatedGuideData.length ? (
                  <>
                    <div className={styles["related-guide-box-title"]}>
                      Related Buying Guides ......
                    </div>
                    <div className={styles["related-guide-box"]}>
                      {relatedGuideData?.map(
                        (product: PopularBuyingGuidesItem, index: number) => (
                          <div className={styles["guides-item"]} key={index}>
                            <GuidesItem
                              type="detail"
                              PopularBuyingGuidesData={product}
                            ></GuidesItem>
                          </div>
                        )
                      )}
                    </div>
                  </>
                ) : null
              }

              {/* facebook comments tools */}
              {width ? (
                <div
                  className="fb-comments"
                  data-width={width}
                  data-numposts="5"
                ></div>
              ) : null}
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  );
}
